import React, { useEffect, useState, useMemo } from "react";
import {
  Flex,
  Table,
  Progress,
  Icon,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Spinner,
  Select,
  Input,
  Button,
  IconButton,
  useToast
} from "@chakra-ui/react";
import {
  useSortBy,
  usePagination,
  useGlobalFilter,
  useTable,
} from "react-table";
import { FiArrowDown, FiArrowUp, FiDownload, FiTrash2, FiEdit } from "react-icons/fi";
import axios from "axios";
import { constants } from "constants/constants";
// Custom components
import Card from "components/card/Card";
import { Link, useHistory } from "react-router-dom";
export default function ComplexTable() {
  const history = useHistory(); // Initialize useHistory hook
  const columnsData = [
    {
      Header: "Batch ID",
      accessor: "id",
      textAlign: "right"
    },
    {
      Header: "Batch Name",
      accessor: "batch_name",
    },
    {
      Header: "Sale Type",
      accessor: "saleType",
    },
    {
      Header: "Customers",
      accessor: "customers",
    },
    {
      Header: "Batch Start & End Date",
      accessor: "start_end_date",
      textAlign: "right"
    },
    {
      Header: "Batch Status",
      accessor: "batch_status",
    },
    {
      Header: "ACTIONS",
      accessor: "",
    },
  ];


  const [isDataLoading, setIsDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalCount, setTotalCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const toast = useToast();

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    gotoPage(newPage - 1); // Manually go to the new page (subtract 1 because react-table uses 0-based indexing)
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setCurrentPage(1); // Reset to the first page when page size changes
    gotoPage(0); // Manually go to the first page (0-indexed)
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
  };


  const fetchDataForPage = async (page, pageSize, searchQuery) => {
    try {
      setIsDataLoading(true);
      const token = localStorage.getItem("accessToken");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(
        `${constants.apiUrl}/fetch-specials-batch`,
        {
          headers,
          withCredentials: true,
          params: {
            page: page,
            pageSize: pageSize,
            search: searchQuery, // Add the search query to the params
          },
        }
      );

      const data = response.data.records;
      setTableData(data);
      setTotalCount(response.data.totalCount);
      setTotalPages(response.data.totalPages);
      setIsDataLoading(false);
    } catch (error) {
      console.error("Error fetching customer data:", error);
      // Handle error if necessary
    } finally {
      setIsDataLoading(false);
    }
  };

  // Fetch data for the initial page

  useEffect(() => {
    if (searchQuery.length >= 2) {
      fetchDataForPage(currentPage, pageSize, searchQuery);
    } else if (searchQuery.length === 0) {
      // Reset the search when searchQuery is empty
      fetchDataForPage(currentPage, pageSize);
    }
  }, [currentPage, pageSize, searchQuery]);

  const handleDownloadCSV = async (batchId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(
        `${constants.apiUrl}/download-specials-batch`,
        {
          headers,
          withCredentials: true,
          params: {
            id: batchId,
          },
          responseType: 'blob', // Important to handle binary data (blob)
        }
      );

      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Specials.CSV';
      link.click();
    } catch (error) {
      console.error("Error downloading CSV:", error);
      // Handle error if necessary
    }
  };

  const handleRemoveBatch = async (batchId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(
        `${constants.apiUrl}/remove-specials-batch`,
        {
          headers,
          withCredentials: true,
          params: {
            id: batchId,
          },
        }
      );

      if (response.status === 200) {
        console.log("Removed Batch ID:", batchId);

        toast({
          position: "bottom-right",
          title: "Specials Batch Removed Successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        fetchDataForPage(currentPage, pageSize);
      } else {
        toast({
          position: "bottom-right",
          title: "There was an error deleting Specials",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

    } catch (error) {
      console.error("Error removing batch:", error);
      toast({
        position: "bottom-right",
        title: "There was an error deleting Specials",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      // Handle error if necessary
    }
  };

  const handleDuplicateBatch = async (batchId, davkaCriteria) => {
    try {


      const token = localStorage.getItem("accessToken");
      const headers = {
        Authorization: `Bearer ${token}`,
      };


      let criteria = '';
      if (davkaCriteria === 'beautymania') {
        criteria = 'BeautyManiaPrice';
      } else if (davkaCriteria === 'kogan') {
        criteria = 'KoganPrice';
      } else if (davkaCriteria === 'mydeal') {
        criteria = 'MyDealPrice';
      }

      let redirectURL = '';

      if (davkaCriteria === 'davkabeauty') {
        redirectURL = `/davkaBeauty-special-review`;
      } else {
        redirectURL = `/special-review?selectedSpecial=${criteria}`;
      }

      const response = await axios.get(
        `${constants.apiUrl}/duplicate-specials-batch`,
        {
          headers,
          withCredentials: true,
          params: {
            id: batchId,
          },
        }
      );

      if (response.status === 200) {
        console.log("Duplicating Batch ID:", batchId);
        // Redirect to the specified page
        history.push(redirectURL);

      }

    } catch (error) {
      console.error("Error removing batch:", error);
      // Handle error if necessary
    }
  };

  const textColor = "gray.900";
  const borderColor = "gray.200";
  const columns = useMemo(() => columnsData, []); // Memoize columnsData, it won't change during the component's lifetime
  const data = useMemo(() => tableData, [tableData]); // Memoize tableData, it will update when tableData changes
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: currentPage - 1,
        pageSize: pageSize,
      },
      // Add this option to make pagination work
      manualPagination: true,
      pageCount: totalPages, // Pass the total number of pages
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <Card
      direction="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      {isDataLoading ? (
        <Flex height="100vh" alignItems="center" justifyContent="center">
          <Spinner size="xl" thickness="4px" color="green.500" />
        </Flex>
      ) : (
        <Flex
          direction="column"
          w="100%"
          px="0px"
          overflowX={{ sm: "scroll", lg: "hidden" }}
        >
          <Flex px="25px" justify="space-between" mb="10px" align="center">
            {/* Page Size Select Dropdown */}
            <Select
              value={pageSize}
              onChange={(e) => handlePageSizeChange(Number(e.target.value))}
              maxWidth="80px"
              variant="outline"
              color={textColor}
            >
              {[5, 10, 25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </Select>

            <Text
              color={textColor}
              fontSize="22px"
              fontWeight="700"
              lineHeight="100%"
            >
              Specials History
            </Text>
            {/* Search Input */}
            <Input
              type="text"
              placeholder="Search"
              onChange={handleSearchChange}
              value={searchQuery}
              maxWidth="200px"
            />
          </Flex>
          <Table
            {...getTableProps()}
            variant="simple"
            color="gray.500"
            mb="24px"
          >
            <Thead>
              {headerGroups.map((headerGroup, index) => (
                <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <Th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      pe="10px"
                      key={index}
                      borderColor={borderColor}
                      style={{ textAlign: column.textAlign }}
                    >
                      <Flex
                        justify="space-between"
                        align="center"
                        fontSize={{ sm: "10px", lg: "12px" }}
                        color="gray.400"
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <Icon as={FiArrowDown} />
                            ) : (
                              <Icon as={FiArrowUp} />
                            )
                          ) : (
                            ""
                          )}
                        </span>
                      </Flex>
                    </Th>
                  ))}
                </Tr>
              ))}
            </Thead>
            <Tbody {...getTableBodyProps()}>
              {page.length === 0 ? (
                <Tr>
                  <Td colSpan={columnsData.length + 1} textAlign="center">
                    No data available.
                  </Td>
                </Tr>
              ) : (
                page.map((row, index) => {
                  prepareRow(row);
                  return (
                    <Tr {...row.getRowProps()} key={index}>
                      {row.cells.map((cell, cellIndex) => {
                        let data;

                        if (columns[cellIndex].Header === "ACTIONS") {
                          data = (

                            <Flex>
                              {/* Duplicate CSV Icon Button */}
                              <Button
                                colorScheme="green"
                                size="sm"
                                onClick={() => handleDuplicateBatch(row.original.id, row.original.davka_criteria)}
                                mr={2}
                              >
                                Duplicate
                              </Button>
                              {/* Download CSV Icon Button */}
                              <Link to={`/update-specials?id=${row.original.id}`}>
                                <IconButton
                                  icon={<FiEdit />}
                                  colorScheme="green"
                                  size="sm"
                                  mr={2}
                                />
                              </Link>
                              <IconButton
                                icon={<FiDownload />}
                                colorScheme="green"
                                size="sm"
                                onClick={() => handleDownloadCSV(row.original.id)}
                                mr={2}
                              />
                              {/* Remove Icon Button */}
                              {row.original.batch_status === 'Completed' && (<IconButton
                                icon={<FiTrash2 />}
                                colorScheme="green"
                                size="sm"
                                onClick={() => handleRemoveBatch(row.original.id)}
                              />)}
                            </Flex>

                          );
                        } else if (columns[cellIndex].Header === "Batch Name") {
                          data = (
                            <Link to={`/view-specials-batch?id=${row.original.id}`}>
                              {/* Display batch_name as the Link text */}
                              <Text fontSize="sm" fontWeight="700">
                                {cell.value}
                              </Text>
                            </Link>
                          );
                        } else {
                          data = (
                            <Text color={textColor} fontSize="sm" fontWeight="700">
                              {cell.value}
                            </Text>
                          );
                        }


                        return (
                          <Td
                            {...cell.getCellProps()}
                            key={cellIndex}
                            fontSize={{ sm: "14px" }}
                            maxH="30px !important"
                            py="8px"
                            minW={{ sm: "150px", md: "200px", lg: "auto" }}
                            borderColor="transparent"
                            textAlign={cell.column.textAlign} // Set textAlign based on tableFormat
                          >
                            {data}
                          </Td>
                        );
                      })}
                    </Tr>
                  );
                })
              )}
            </Tbody>


          </Table>
          {/* Pagination */}
          <Flex
            justifyContent="space-between"
            alignItems="center"
            px="25px"
            mb="10px"
          >
            <Flex>
              <Button
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1} // Disable the button when on the first page
                variant="link"
                color={textColor}
              >
                {"<<"}
              </Button>
              <Button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1} // Disable the button when there are no previous pages or on the first page
                variant="link"
                color={textColor}
              >
                {"<"}
              </Button>

              <Button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages} // Disable the button when there are no next pages or on the last page
                variant="link"
                color={textColor}
              >
                {">"}
              </Button>
              <Button
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages} // Disable the button when on the last page
                variant="link"
                color={textColor}
              >
                {">>"}
              </Button>
              <Text color={textColor} fontSize="sm" fontWeight="700">
                Page{" "}
                <Text as="span" color={textColor}>
                  {currentPage} of {totalPages}
                </Text>{" "}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      )}
    </Card>
  );
}
